module.exports = __webpack_public_path__ + "img/add_blue.1a64b850.svg";